export default {"src":"/_next/static/media/stressMotivation.95b0201b.svg","height":616,"width":1044,"blurWidth":0,"blurHeight":0};